module.exports = __webpack_public_path__ + "img/colleagues.62c54a53.png";